import { Range } from '@root/types';

const getBarColors = (userRange: Range, labels: Range[]) => {
  const colors = ['#868686', '#9C9C9C', '#B5B5B5', '#BDBDBD', '#D4D4D4'];
  const barColors = labels.map((label, index) => {
    if (label === userRange) {
      return '#35597C';
    }
    return colors[index];
  });
  return barColors;
};

export default getBarColors;
